import * as React from 'react';
import './styles.css';

// tslint:disable-next-line:no-any
declare const DocumentTouch: any;
const isTouchDevice = () => {
      var prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
      let mq = (q: string) => {
            return window.matchMedia(q).matches;
      };

      // tslint:disable-next-line:no-string-literal
      if (('ontouchstart' in window) || window['DocumentTouch'] && document instanceof DocumentTouch) {
            return true;
      }

      // include the 'heartz' as a way to have a non matching MQ to help terminate the join
      // https://git.io/vznFH
      var query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
      return mq(query);
};
const isTouch = isTouchDevice();

export interface Props {
      showLightbox: boolean;
      showCaption: boolean;
      menuCollapsed: boolean;

      changeLightbox: (l: boolean) => void;
      changeCaption: (c: boolean) => void;
      isMouseOver: (c: boolean) => void;
}

class Menu extends React.Component<Props> {
      constructor(props: Props) {
            super(props);

            this._handleLighrboxClick = this._handleLighrboxClick.bind(this);
            this._handleCaptionClick = this._handleCaptionClick.bind(this);
            this._handleCaptionMouseEnter = this._handleCaptionMouseEnter.bind(this);
            this._handleCaptionMouseLeave = this._handleCaptionMouseLeave.bind(this);
      }

      render() {
            return (
                  <div className="menu">
                        <a
                              className="menu__link"
                              onClick={this._handleLighrboxClick}
                        >
                              Info
                        </a>
                        <a
                              className="menu__link"
                              onClick={this._handleCaptionClick}
                              onMouseEnter={this._handleCaptionMouseEnter}
                              onMouseLeave={this._handleCaptionMouseLeave}
                        >
                              {this.props.menuCollapsed ? '+' : 'Captions'}
                        </a>
                        {this.props.children}
                  </div>);
      }

      private _handleCaptionClick(e: React.MouseEvent<HTMLAnchorElement>) {
            e.stopPropagation();
            e.preventDefault();
            this.props.changeCaption(!this.props.showCaption);
      }

      private _handleCaptionMouseEnter() {
            if (!isTouch) {
                  this.props.isMouseOver(true);
            }
      }

      private _handleCaptionMouseLeave() {
            if (!isTouch) {
                  this.props.isMouseOver(false);
            }
      }

      private _handleLighrboxClick() {
            this.props.changeLightbox(!this.props.showLightbox);
      }
}

export default Menu; 


// WEBPACK FOOTER //
// ./src/components/Menu/Component.tsx